export default __webpack_public_path__ + "static/media/map_selected.c7d8f5af.svg";